// ie 지원용이나 차후 수정한다. (babel-polyfill 전체를 임포트하는 것은 비효율임)
import 'babel-polyfill';

import React from 'react';
import ReactDOM from 'react-dom';
import { CookiesProvider } from 'react-cookie';

// import 'semantic-ui-css/semantic.min.css';
import 'bootstrap/dist/css/bootstrap.css';
import './custom_semantic/semantic.min.css';
import { MuiThemeProvider } from 'material-ui/styles';
import theme from './materialUiTheme';

import 'react-table/react-table.css';
 
import App from './App';
import modules from './script/modules';

import { createStore, applyMiddleware } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import ReduxThunk from 'redux-thunk';
import { Provider } from 'react-redux';
import penderMiddleware from 'redux-pender';
import injectTapEventPlugin from 'react-tap-event-plugin';

import { detect } from 'detect-browser';
import MobileDetect from 'mobile-detect';

import * as commonVar from 'libs/commonVar';

import { IntlProvider, addLocaleData } from 'react-intl';
import ko from 'react-intl/locale-data/ko';
import en from 'react-intl/locale-data/en';
import ja from 'react-intl/locale-data/ja';

import localeData from './i18n/data.json';

addLocaleData([...ko, ...en, ...ja]);
let language = (navigator.languages && navigator.languages[0]) || navigator.language || navigator.userLanguage;
const languageWithoutRegionCode = language.toLowerCase().split(/[_-]+/)[0];
let messages = localeData[languageWithoutRegionCode] || localeData[language] || localeData.ko;

document.body.classList.remove('ja');
document.body.classList.remove('en');

if (!!localStorage.getItem('language')) {
  language = localStorage.getItem('language') || language;
  messages = localeData[language] || localeData.ko;
  document.body.classList.toggle(language, language === 'ja' || language === 'en');
} else {
  if (languageWithoutRegionCode === 'ja') {
    localStorage.setItem('language', 'ja');
    document.body.classList.toggle('ja', true);
  } else {
    localStorage.setItem('language', 'ko');
  }
}

// 브라우저 버전 체크
const browser = detect();
if (browser) {
  if (
    browser.name === 'chrome' ||
    browser.name === 'firefox' ||
    browser.name === 'edge' ||
    browser.name === 'firefox' ||
    (browser.name === 'ie' && parseInt(browser.version.split(',')[0])) > 10
  ) {
    //
  } else {
    window.location.href = '/browserVersion_' + localStorage.getItem('language') + '.html';
  }
}

// 모바일 체크
const md = new MobileDetect(window.navigator.userAgent);
if (!!md.mobile()) {
  // if (commonVar.isJapan === 1) {
  if (localStorage.getItem('language') === 'ja') {
    window.location.href = 'https://www.jsecurity.co.jp/mudfix';
  } else {
    window.location.href = 'https://www.jiransecurity.com/products/mudfix';
  }
}

const store = createStore(modules, composeWithDevTools(applyMiddleware(ReduxThunk, penderMiddleware())));

injectTapEventPlugin();

ReactDOM.render(
  <IntlProvider locale={language} messages={messages}>
    <Provider store={store}>
      <MuiThemeProvider theme={theme}>
        <CookiesProvider>
          <App />
        </CookiesProvider>
      </MuiThemeProvider>
    </Provider>
  </IntlProvider>,
  document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js